import { closeModalSelector, openModalSelector, useModalStore } from '@store';

export const useEditDatesModal = () => {
  const openModal = useModalStore(openModalSelector);
  const closeModal = useModalStore(closeModalSelector);
  const onNext = async () => {
    closeModal();
  };

  const openEditDatesModal = () =>
    openModal('Modal', {
      body: {
        type: 'SelectTravelDates',
        isModal: true,
        onNext: onNext,
        onBack: closeModal,
      },
      size: 'lg',
      sendExitEvent: true,
    });

  return { openEditDatesModal };
};
